import PubSub from 'pubsub-js';
import { PageEvents } from './page';
import { TextColorCheck } from '../utils/textColorCheck';
import { Responsive } from '../utils';

import './news.scss';

const COMPONENT_NAME = 'news';
const BEM = {
  BLOCK: COMPONENT_NAME,
  ELEMENT_SLIDER: 'news__slider',
  ELEMENT_SLIDER_ITEM: 'news__slider__item',
  ELEMENT_SLIDE: 'news__slide',
};

/**
 * version    1.0
 * class      <type> (News)
 */
export class News {
  constructor() {
    const self = this;

    this._els = {
      news: $(`.${BEM.BLOCK}`),
    };

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      self._els.news.each(function () {
        const $instanceEl = $(this);

        self._initSingleInstance($(this));
        TextColorCheck._checkBackground($instanceEl);
      });
    });
  }

  // private methods

  _initSingleInstance($instanceEl) {
    const self = this;
    const isMuseoSlider = self._els.news.hasClass('news--slider');
    const iframeEl = $instanceEl.find('iframe');

    if (isMuseoSlider) {
      self._initMuseoSlider($instanceEl);
    }

    if (iframeEl.length > 0) {
      self._resizeIframe(iframeEl);
    }
  }

  _resizeIframe(iframeEl) {
    const self = this;
    const $iframe = iframeEl;
    const isDesktop = self._checkIfDesktop();
    const desktopHeight = $iframe.data('height') ? $iframe.data('height') : '380px';
    const mobileHeight = $iframe.data('mobile-height') ? $iframe.data('mobile-height') : desktopHeight;
    const heightIframe = isDesktop ? desktopHeight : mobileHeight;

    $iframe.css('height', heightIframe);
  }

  _checkIfDesktop() {
    // Si suppone "desktop" solo da 1025px di larghezza del viewport in su; altrimenti è "mobile".
    // È l'unica distinzione presa in esame.
    const breakpoint = Responsive.getCurrentBreakpointName();
    return breakpoint === 'md' || breakpoint === 'lg';
  }

  _initMuseoSlider($instanceEl) {
    const $sliderItems = $instanceEl.find(`.${BEM.ELEMENT_SLIDER_ITEM}`);

    const optionsSlider = {
      infinite: false,
      slidesToShow: 2.5,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      variableWidth: false,
      nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg role="img" class="svg-icon svg-icon--arrow-right-slider" title="Next"><use xlink:href="#sprite-arrow-right-slider"></use></svg></button>',
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg role="img" class="svg-icon svg-icon--arrow-left-slider" title="Previous"><use xlink:href="#sprite-arrow-left-slider"></use></svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
          },
        },
      ],
    };

    if ($sliderItems.length > 1) {
      $instanceEl.find(`.${BEM.ELEMENT_SLIDER}`).slick(optionsSlider);
    }
  }
}
